import { Button, Card, Space } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function InvoicePaymentTable() {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Client Name",
      dataIndex: "client_name",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/payment?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [tableData, setTableData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const handleAddPayment = () => {
    navigate("/portal/payment/add");
  };

  const editRecord = (record) => {
    navigate("/portal/payment/add", {
      state: record,
    });
  };

  const onPaginationChange = (page) => {
    getRequest(null, API_METHODS.GET, `/payment?pageNumber=${page.current}`);
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Payments"
      extra={
        <Button type="primary" onClick={handleAddPayment}>
          Add Invoice Payment
        </Button>
      }
    >
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </Card>
  );
}

export default InvoicePaymentTable;
